var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spread = (this && this.__spread) || function () {
    for (var ar = [], i = 0; i < arguments.length; i++) ar = ar.concat(__read(arguments[i]));
    return ar;
};
import { px } from './px';
/**
 * spacing
 * @param values
 */
export function spacing() {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    return function (_a) {
        var theme = _a.theme;
        var unit = theme.spacing(1);
        return px.apply(void 0, __spread(values.map(function (n) { return n * unit; })));
    };
}
export function toSpacing(value) {
    return value / 4;
}
/**
 * spacing unit value
 * @param values
 */
export function spacingUnit(values) {
    return function (_a) {
        var theme = _a.theme;
        var unit = theme.spacing(1);
        return values * unit;
    };
}
